// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3Imse","row":"ProcedureTreatmentSummary_row__kHsPR"};